import {
  SEND_SHARE_DATA_FAIL,
  SEND_SHARE_DATA_REQUEST,
  SEND_SHARE_DATA_SUCCESS,
} from "../../ActionType/SharedType/sharedDataType";
import { api } from "../../Api/api";

export const sendSharedData = (link) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    dispatch({ type: SEND_SHARE_DATA_REQUEST });
    const res = await api.post("storage", { key: "token", value: token });
       console.log(res)
    if (res.status == 200) {
      dispatch({ type: SEND_SHARE_DATA_SUCCESS });
      window.location.href = link;
    }
  } catch (error) {
    dispatch({ type: SEND_SHARE_DATA_FAIL });

    console.log(error);
  }
};
